export default {
    topics: [
        {
            title: ' DOMDocument ',
            href: 'm-DOMDocument-DOMDocument.html',
            attributes: { 'data-id': 'm-DOMDocument-DOMDocument' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-DOMDocument-d66e6895',
            topics: [],
        },
        {
            title: ' createCDATASection ',
            href: 'm-DOMDocument-createCDATASection.html',
            attributes: { 'data-id': 'm-DOMDocument-createCDATASection' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createCDATASection-d66e6903',
            topics: [],
        },
        {
            title: ' createComment ',
            href: 'm-DOMDocument-createComment.html',
            attributes: { 'data-id': 'm-DOMDocument-createComment' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createComment-d66e6911',
            topics: [],
        },
        {
            title: ' createElement ',
            href: 'm-DOMDocument-createElement.html',
            attributes: { 'data-id': 'm-DOMDocument-createElement' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createElement-d66e6919',
            topics: [],
        },
        {
            title: ' createElementNS ',
            href: 'm-DOMDocument-createElementNS.html',
            attributes: { 'data-id': 'm-DOMDocument-createElementNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createElementNS-d66e6927',
            topics: [],
        },
        {
            title: ' createEntityReference ',
            href: 'm-DOMDocument-createEntityReference.html',
            attributes: { 'data-id': 'm-DOMDocument-createEntityReference' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createEntityReference-d66e6935',
            topics: [],
        },
        {
            title: ' createProcessingInstruction ',
            href: 'm-DOMDocument-createProcessingInstruction.html',
            attributes: { 'data-id': 'm-DOMDocument-createProcessingInstruction' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createProcessingInstruction-d66e6943',
            topics: [],
        },
        {
            title: ' createTextNode ',
            href: 'm-DOMDocument-createTextNode.html',
            attributes: { 'data-id': 'm-DOMDocument-createTextNode' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-createTextNode-d66e6951',
            topics: [],
        },
        {
            title: ' documentElement ',
            href: 'p-DOMDocument-documentElement.html',
            attributes: { 'data-id': 'p-DOMDocument-documentElement' },
            menu: { hasChildren: false },
            tocID: 'p-DOMDocument-documentElement-d66e6959',
            topics: [],
        },
        {
            title: ' documentURI ',
            href: 'p-DOMDocument-documentURI.html',
            attributes: { 'data-id': 'p-DOMDocument-documentURI' },
            menu: { hasChildren: false },
            tocID: 'p-DOMDocument-documentURI-d66e6967',
            topics: [],
        },
        {
            title: ' fromJXON ',
            href: 'm-DOMDocument-fromJXON.html',
            attributes: { 'data-id': 'm-DOMDocument-fromJXON' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-fromJXON-d66e6976',
            topics: [],
        },
        {
            title: ' fromXMLString ',
            href: 'm-DOMDocument-fromXMLString.html',
            attributes: { 'data-id': 'm-DOMDocument-fromXMLString' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-fromXMLString-d66e6984',
            topics: [],
        },
        {
            title: ' getElementById ',
            href: 'm-DOMDocument-getElementById.html',
            attributes: { 'data-id': 'm-DOMDocument-getElementById' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-getElementById-d66e6992',
            topics: [],
        },
        {
            title: ' getElementsByTagName ',
            href: 'm-DOMDocument-getElementsByTagName.html',
            attributes: { 'data-id': 'm-DOMDocument-getElementsByTagName' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-getElementsByTagName-d66e7000',
            topics: [],
        },
        {
            title: ' getElementsByTagNameNS ',
            href: 'm-DOMDocument-getElementsByTagNameNS.html',
            attributes: { 'data-id': 'm-DOMDocument-getElementsByTagNameNS' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-getElementsByTagNameNS-d66e7008',
            topics: [],
        },
        {
            title: ' importNode ',
            href: 'm-DOMDocument-importNode.html',
            attributes: { 'data-id': 'm-DOMDocument-importNode' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-importNode-d66e7016',
            topics: [],
        },
        {
            title: ' load ',
            href: 'm-DOMDocument-load.html',
            attributes: { 'data-id': 'm-DOMDocument-load' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-load-d66e7024',
            topics: [],
        },
        {
            title: ' normalizeDocument ',
            href: 'm-DOMDocument-normalizeDocument.html',
            attributes: { 'data-id': 'm-DOMDocument-normalizeDocument' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-normalizeDocument-d66e7032',
            topics: [],
        },
        {
            title: ' renameNode ',
            href: 'm-DOMDocument-renameNode.html',
            attributes: { 'data-id': 'm-DOMDocument-renameNode' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-renameNode-d66e7040',
            topics: [],
        },
        {
            title: ' root ',
            href: 'p-DOMDocument-root.html',
            attributes: { 'data-id': 'p-DOMDocument-root' },
            menu: { hasChildren: false },
            tocID: 'p-DOMDocument-root-d66e7048',
            topics: [],
        },
        {
            title: ' toXMLString ',
            href: 'm-DOMDocument-toXMLString.html',
            attributes: { 'data-id': 'm-DOMDocument-toXMLString' },
            menu: { hasChildren: false },
            tocID: 'm-DOMDocument-toXMLString-d66e7056',
            topics: [],
        },
    ],
};

